import { httpClient } from "infra/axios/axios-api";
import { Expense } from "domain/entities/expense";
import { ExpenseStatusEnum } from "domain/enum/expenseStatus";
import { MessageTypeEnum } from "domain/enum/messageType";
import Spinner from "presentation/components/Shared/Spinner";
import { useExpenseById, useUpdateExpenseMutation } from "presentation/hooks/use-query-expense";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";

interface ParamProps {
  expense: Expense | null;
  onClose(): void;
  showMessage(
    type: MessageTypeEnum,
    subject: string,
    message: string
  ): void;
}

const ApprovalForm: React.FC<ParamProps> = (props: ParamProps) => {
  const { showMessage, onClose } = props;

  const toast = useRef<Toast>(null);
  const { email: userEmployeeEmail } = useAuthStore();
  const [url, setUrl] = useState("");
  const [confirmAction, setConfirmAction] = useState<'approve' | 'reject' | null>(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [visibleRejectionReason, setVisibleRejectionReason] = useState(false);
  const [reasonReject, setReasonReject] = useState("");
  const possibleApprovalStatus = [ExpenseStatusEnum.PENDENTE.toString()];

  const { mutate: updateExpense, isSuccess: isSuccessUpdateExpense, isError: isErrorUpdateExpense, isPending: isPendingUpdateExpense } =
    useUpdateExpenseMutation();

  const { data: expenseData } = useExpenseById(
    props.expense?.id
  );


  useEffect(() => {
    const fetchSignedUrl = async () => {
      if (!props.expense?.document.fullPath) return;

      try {
        const response = await httpClient.get(
          `/assets/${props.expense.document.fullPath}`
        );
        setUrl(response.data.url);
      } catch (err) {
        console.error("Erro ao buscar signed URL:", err);
      }
    };

    fetchSignedUrl();
  }, [props.expense]);



  useEffect(() => {
    if (isSuccessUpdateExpense) {
      if (expenseData?.data?.status === ExpenseStatusEnum.APROVADO) {
        showMessage(
          MessageTypeEnum.SUCCESS,
          "Workflow",
          "Documento foi aprovado com sucesso"
        );
      } else if (expenseData?.data?.status === ExpenseStatusEnum.NAO_APROVADO) {
        showMessage(
          MessageTypeEnum.SUCCESS,
          "Workflow",
          "Documento foi reprovado com sucesso"
        );
      }

      onClose();
    }
  }, [isSuccessUpdateExpense, expenseData?.data?.status, showMessage, onClose]);


  useEffect(() => {
    if (isErrorUpdateExpense) {
      if (expenseData?.data?.status === ExpenseStatusEnum.APROVADO) {
        showMessage(
          MessageTypeEnum.ERROR,
          "Workflow",
          "Erro ao aprovar documento"
        );
      } else if (expenseData?.data?.status === ExpenseStatusEnum.NAO_APROVADO) {
        showMessage(
          MessageTypeEnum.ERROR,
          "Workflow",
          "Erro ao reprovar documento"
        );
      }

      onClose();
    }
  }, [isErrorUpdateExpense, expenseData?.data?.status, showMessage, onClose]);

  const handleApprove = () => {
    const expense = expenseData?.data;
    console.log(expenseData);
    console.log("p1" + expense?.status + userEmployeeEmail);
    if (expense && expense.status === ExpenseStatusEnum.PENDENTE && userEmployeeEmail) {
      console.log("p2" + expense);
      expense.status = ExpenseStatusEnum.APROVADO;
      expense.lastModifiedBy = userEmployeeEmail;
      updateExpense(expense);
    }
    console.log("p3" + expense);
    setShowConfirm(false);
    setConfirmAction(null);
  };

  const handleReject = () => {
    const expense = expenseData?.data;
    if (expense && expense.status === ExpenseStatusEnum.PENDENTE && userEmployeeEmail) {
      expense.status = ExpenseStatusEnum.NAO_APROVADO;
      expense.rejectionReason = reasonReject;
      expense.lastModifiedBy = userEmployeeEmail;
      updateExpense(expense);
    }
    setVisibleRejectionReason(false);
    setConfirmAction(null);
  };

  if (isPendingUpdateExpense) return <Spinner />;

  return (
    <div>
      {" "}
      <div>
        <ConfirmDialog
          visible={showConfirm}
          onHide={() => setShowConfirm(false)}
          message={
            confirmAction === 'approve'
              ? 'Deseja aprovar este documento?'
              : 'Deseja rejeitar este documento, sendo este o motivo?'}
          header="Confirmação"
          icon="pi pi-exclamation-triangle"
          accept={() => {
            if (confirmAction === "approve") handleApprove();
            if (confirmAction === "reject") {
              setVisibleRejectionReason(false);
              handleReject();
            }
          }}
          reject={() => setShowConfirm(false)}
          acceptLabel="Sim"
          rejectLabel="Não"
        />
        {url && (url.includes('.pdf') ? (
          <iframe
            src={`${url}#navpanes=0`}
            width="100%"
            height="700px"
            title="Expense"
            style={{ border: "none" }}
          ></iframe>) :
          (
            <img src={url}
              alt="Expense Document"
              width="100%"
              height="auto"
              title="Expense"
              style={{ border: "none" }}>
            </img>
          )
        )}

        {possibleApprovalStatus.includes(props.expense?.status ?? "") && (
          <div style={{ textAlign: "right", marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "15px" }}>
            <Button
              label="Rejeitar"
              className="p-button-danger"
              icon="pi pi-times"
              onClick={() => {
                setReasonReject("");
                setVisibleRejectionReason(true);
              }}
            />
            <Button
              label="Aprovar"
              icon="pi pi-check"
              onClick={() => {
                setConfirmAction("approve");
                setShowConfirm(true);
              }}
            />
          </div>
        )
        }

      </div>
      <Dialog
        header="Rejeição do Documento"
        visible={visibleRejectionReason}
        style={{ width: "30vw" }}
        modal
        onHide={() => setVisibleRejectionReason(false)}
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="motivo">Informe o Motivo da Rejeição:</label>
            <InputTextarea
              id="motivo"
              value={reasonReject}
              onChange={(e) => setReasonReject(e.target.value)}
              rows={4}
              autoFocus
              maxLength={190}
            />
            <div className="flex justify-content-end">
              <small>{reasonReject?.length}/190 caracteres</small>
            </div>
          </div>
          <div className="flex justify-content-end gap-2 mt-3">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              onClick={() => setVisibleRejectionReason(false)}
            />
            <Button
              label="Rejeitar"
              icon="pi pi-check"
              onClick={() => {
                if (reasonReject.trim() !== "") {
                  setConfirmAction("reject");
                  setShowConfirm(true);
                } else {
                  toast.current?.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Informe o motivo da não aprovação do documento.",
                    life: 6000,
                  });
                }
              }}
              autoFocus
            />
          </div>
        </div>
      </Dialog>

      <Toast ref={toast} position="bottom-right" />

    </div>
  );
};

export default ApprovalForm;
